<script>
</script>

<div>
  <h6>
    © 2023 &nbsp; <span style="font-weight: 100;">Lern</span> <span style="font-weight: 600;">Live</span>&nbsp; | A brand of FortunaPIX®
  </h6>
</div>

<style>
  div {
    height: 64px;
    display: flex;
    align-items: center;
  }

  h6 {
    color: #fff;
    display: flex;
    align-items: center;
  }
</style>
